import { proforientationEventSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationEventExcursionsYearsSelector = createSelector(
  [proforientationEventSelectors.excursions],
  (proforientationEventExcursions) =>
    extractDatesFromNestedItems(
      [proforientationEventExcursions],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
